<template>
  <div class="main-container flex-column align-items-center justify-content-center">
    <b-row>
      <b-col md="12">
        <div class="clearfix text-center">
          <h1>Unauthorized Account</h1>
          <h4 class="pt-3">Please use agency or warehouse account!</h4>
          <router-link to="/login">Go to Login</router-link>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'PageUnauthorized',
};
</script>
